import { render, staticRenderFns } from "./warehouseconsumabletype-form.vue?vue&type=template&id=1492a85e&scoped=true&"
import script from "./warehouseconsumabletype-form.vue?vue&type=script&lang=js&"
export * from "./warehouseconsumabletype-form.vue?vue&type=script&lang=js&"
import style0 from "./warehouseconsumabletype-form.vue?vue&type=style&index=0&id=1492a85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492a85e",
  null
  
)

export default component.exports